import { h } from 'preact';
import Store from 'store/store';
import * as jsonPointer from 'utils/jsonPointer';

import FieldBase from 'components/editor/settings/fieldBase';
import InlineSelect from 'components/inlineSelect/inlineSelect';

import s from 'components/editor/settings/dateField.sss';

// TODO: custom date picker (nicer than native)
export default class DateField extends FieldBase {
	s = s;

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			precision: !props.allowCustomPrecision ? 'date' : this.getDatePrecision(this.getValue(props)),
		};

		this.updatePrecision = this.updatePrecision.bind(this);
		this.onInput = this.onInput.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		super.componentWillReceiveProps?.(nextProps);
		if (nextProps.allowCustomPrecision && (nextProps.path || nextProps.value !== this.props.value)) {
			const currentValue = this.getValue(nextProps);
			if (currentValue) {
				const precision = this.getDatePrecision(currentValue);
				if (precision !== this.state.precision) {
					this.setState({ precision });
				}
			}
		}
	}

	getDatePrecision(value) {
		if (!value) return 'date';
		return ['', 'year', 'month', 'date'][value?.split('-').length] || 'date';
	}

	getInputType(precision = this.state.precision) {
		if (precision === 'year') return 'number';
		if (precision === 'month') return 'month';
		return 'date';
	}

	// TODO: save the more precise value when switching the precision down then back up?
	updatePrecision(e) {
		const precision = e.target.value;
		const input = this.base.querySelector(`.${s.field}`);
		const previousValue = input?.value || '';
		this.setState({ precision });
		const parts = previousValue.split('-').concat('01', '01');
		let newValue = parts.slice(0, { date: 3, month: 2, year: 1 }[precision] || 3).join('-');
		if (input && newValue !== previousValue) {
			input.type = this.getInputType(precision);
			input.value = newValue;
			input.dispatchEvent(new Event('input'));
		}
	}

	onInput(e) {
		this.props.onInput?.(e);
		if (!this.props.path) return;
		jsonPointer.setDeep(Store.get().data, this.props.path, e.target.value);
	}

	renderName() {
		return (
			<div class={this.s.name} key="name">
				{this.renderToggleableToggle()}
				{this.props.label}
				{this.props.grayText && <span class={s.gray}>{this.props.grayText}</span>}
				{!!this.props.allowCustomPrecision && !this.props.hidePrecisionSelector && (
					<InlineSelect small name={`${this.state.id}-precision`} value={this.state.precision} onChange={this.updatePrecision}>
						<option value="date">Full Date</option>
						<option value="month">Month</option>
						<option value="year">Year</option>
					</InlineSelect>
				)}
				{this.renderHelp()}
			</div>
		);
	}

	renderField() {
		const props = this.props;
		const state = this.state;
		const value = this.getValue();
		return (
			<input
				class={s.field}
				type={this.getInputType()}
				id={state.id}
				name={props.name}
				// Do not use the value attribute if uncontrolled to avoid resetting on render
				{...(value != undefined ? { value } : {})}
				min={props.min}
				max={props.max}
				required={props.required}
				readonly={this.readonly}
				disabled={this.disabled}
				onInput={this.onInput}
			/>
		);
	}
}
